module.exports = __webpack_public_path__ + "img/404.a554cfb8.jpg";